import { Invoice, Statement } from "core/models/statement";
import PagerStore from "core/stores/pager.store";

export enum ItemType {
    invoice = "Invoice",
    statement = "Statement"
}

class StatementsAndInvoicesStore extends PagerStore<Statement | Invoice> {
}

export default StatementsAndInvoicesStore;
